"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgRightInsert = function SvgRightInsert(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("g", {
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("path", {
    d: "M690 141.73v1512H140v-1512h550m140-140H0v1792h830V1.73zM1632 2.73h160v160h-160zM1792 1556.3h-160v-154.84h160zm0-232.26h-160V1169.2h160zm0-232.26h-160V936.94h160zm0-232.26h-160V704.67h160zm0-232.27h-160V472.41h160zm0-232.25h-160V240.15h160zM1632 1633.73h160v160h-160zM1554.14 1793.73h-155.71v-160h155.71zm-233.57 0h-155.71v-160h155.71zM927 1633.73h160v160H927zM1087 1556.3H927v-154.84h160zm0-232.26H927V1169.2h160zm0-232.26H927V936.94h160zm0-232.26H927V704.67h160zm0-232.27H927V472.41h160zm0-232.25H927V240.15h160zM927 2.73h160v160H927zM1554.14 162.73h-155.71v-160h155.71zm-233.57 0h-155.71v-160h155.71zM1595 811.73h-165v-165h-150v165h-165v150h165v165h150v-165h165v-150z"
  })));
};
exports.default = SvgRightInsert;